import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { EMULATOR_APP_CONFIG } from '../firebase-emulators';

// This should match the structure returned by your Firebase Function
export interface AppConfig {
    production: boolean;
    adminEmail: string;
    geminiApiKey?: string;
    firebase: {
        apiKey: string;
        authDomain: string;
        projectId: string;
        storageBucket: string;
        messagingSenderId: string;
        appId: string;
        measurementId?: string;
    };
    firebasePhotoLavie?: {
        apiKey: string;
        authDomain: string;
        projectId: string;
        storageBucket: string;
        messagingSenderId: string;
        appId: string;
    };
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private appConfig!: AppConfig;
  private configUrl = environment.configUrl;

  constructor(private http: HttpClient) { }

  async loadAppConfig(): Promise<AppConfig> {
    if (EMULATOR_APP_CONFIG) { // KAN-735: e2e-emulator build only; null in every real build
      this.appConfig = EMULATOR_APP_CONFIG;
      return this.appConfig;
    }
    this.appConfig = await firstValueFrom(this.http.get<AppConfig>(this.configUrl));
    return this.appConfig;
  }

  getConfig(): AppConfig {
    if (!this.appConfig) {
      throw new Error('Configuration not loaded!');
    }
    return this.appConfig;
  }
}